/** User preference: keep auth session in localStorage (survives browser restarts). */
export const REMEMBER_ME_KEY = 'disenchantment-remember-me';
/** Optional saved login email when remember-me is enabled. */
export const SAVED_LOGIN_EMAIL_KEY = 'disenchantment-login-email';
const SUPABASE_AUTH_KEY_PREFIX = 'sb-';
const SUPABASE_AUTH_KEY_SUFFIX = '-auth-token';
export function getRememberMe() {
    if (typeof window === 'undefined')
        return true;
    return localStorage.getItem(REMEMBER_ME_KEY) !== '0';
}
export function setRememberMe(remember) {
    localStorage.setItem(REMEMBER_ME_KEY, remember ? '1' : '0');
}
export function getSavedLoginEmail() {
    if (typeof window === 'undefined')
        return '';
    if (!getRememberMe())
        return '';
    return localStorage.getItem(SAVED_LOGIN_EMAIL_KEY)?.trim() ?? '';
}
export function setSavedLoginEmail(email, remember) {
    if (!remember) {
        localStorage.removeItem(SAVED_LOGIN_EMAIL_KEY);
        return;
    }
    const trimmed = email.trim();
    if (trimmed)
        localStorage.setItem(SAVED_LOGIN_EMAIL_KEY, trimmed);
}
export function getAuthStorage() {
    return getRememberMe() ? localStorage : sessionStorage;
}
/** Supabase-compatible storage that respects the remember-me preference. */
export const authStorageAdapter = {
    getItem(key) {
        return getAuthStorage().getItem(key);
    },
    setItem(key, value) {
        getAuthStorage().setItem(key, value);
    },
    removeItem(key) {
        getAuthStorage().removeItem(key);
    },
};
export function isSupabaseAuthStorageKey(key) {
    return key.startsWith(SUPABASE_AUTH_KEY_PREFIX) && key.endsWith(SUPABASE_AUTH_KEY_SUFFIX);
}
/** Remove Supabase session keys from a storage bucket (e.g. when switching remember-me). */
export function clearSupabaseAuthInStorage(storage) {
    const keys = [];
    for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key && isSupabaseAuthStorageKey(key))
            keys.push(key);
    }
    for (const key of keys)
        storage.removeItem(key);
}
export function clearAllSupabaseAuthStorage() {
    clearSupabaseAuthInStorage(localStorage);
    clearSupabaseAuthInStorage(sessionStorage);
    localStorage.removeItem('sb-access-token');
}
//# sourceMappingURL=persistence.js.map